import { defineFilters, text } from '@/components/kit/filters'

/**
 * Search only. The endpoint matches the affiliate code with a case-insensitive
 * regex and ignores everything else, so offering a filter it silently drops would
 * be worse than offering none.
 */
export const affiliateFilters = defineFilters(
    {
        search: text({ label: 'Code' })
    },
    { defaultLimit: 20 }
)

export type AffiliateSearch = ReturnType<typeof affiliateFilters.parse>
